import { cn } from "@/lib/utils"
import * as React from "react"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					"df-input df-input-base border-input flex h-12 w-full rounded-full border px-4 py-2 text-xs transition-all duration-200",
					"file:text-foreground file:border-0 file:bg-transparent file:text-sm file:font-medium",
					"placeholder:text-fieldPlaceholder",
					"focus-visible:border-ring focus-visible:shadow-[0_0_0_3px_hsl(var(--ring)/0.12)] focus-visible:outline-none",
					"focus:df-input-focus",
					"disabled:cursor-not-allowed disabled:opacity-50",
					"md:text-sm",
					className,
				)}
				ref={ref}
				{...props}
			/>
		)
	},
)
Input.displayName = "Input"

export { Input }
